import api from '@/api/expectedPayments';

const state = {
    items: [],
    loading: false
};

const getters = {
    items: state => state.items,
    loading: state => state.loading
};

const actions = {
    async fetchItems({ commit }, params) {
        commit('setLoading', true);
        try {
            const response = await api.getAll(params);
            commit('setItems', response.data);
        } catch (error) {
            console.error('ExpectedPaymentItems fetch error:', error);
            commit('setItems', []);
        } finally {
            commit('setLoading', false);
        }
    },
    async createItem({ dispatch }, data) {
        try {
            await api.create(data);
            await dispatch('fetchItems', { tenantId: data.tenantId, mpId: data.mpId });
        } catch (error) {
            console.error('ExpectedPaymentItem create error:', error);
            throw error;
        }
    },
    async updateItem({ dispatch }, data) {
        try {
            await api.update(data.id, data);
            await dispatch('fetchItems', { tenantId: data.tenantId, mpId: data.mpId });
        } catch (error) {
            console.error('ExpectedPaymentItem update error:', error);
            throw error;
        }
    },
    async deleteItem({ dispatch }, { id, tenantId, mpId }) {
        try {
            await api.delete(id);
            await dispatch('fetchItems', { tenantId, mpId });
        } catch (error) {
            console.error('ExpectedPaymentItem delete error:', error);
            throw error;
        }
    }
};

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    setLoading(state, loading) {
        state.loading = loading;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

